import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import api from "../../services/api";

import { Container, Login, Close } from "./styles";

import AuthActions from "../../storeChat/ducks/auth";
import ChatActions from "../../store/ducks/chat";
import MessagesActions from "../../store/ducks/messages";

import PrimaryButton from "../../components/PrimaryButton";

import Users from "./Users";
import Chat from "./Chat";

class ChatContainer extends Component {
  state = {
    loading: false
  };

  componentDidMount() {
    if (!this.props.auth.user.customer) {
      this.props.getUser();
    } else {
      this.props.getUsers(
        this.props.auth.user.customer.key,
        this.props.auth.user._id,
        this.props.auth.user.admin
      );
    }
  }

  handleLogin = async () => {
    this.setState({
      loading: true
    });

    const tenant = await api.get("/company");

    const customerEmail = tenant.data.resp_email
      ? tenant.data.resp_email
      : `${tenant.data.name.toLowerCase().replace(/ /g, "")}@mail.com`;

    const email = `${tenant.data.id}${this.props.user.id}${customerEmail}`;
    const password = `${tenant.data.id}${this.props.user.id}#54578`;

    this.props.signInRequest(email, password);

    this.setState({
      loading: false
    });
  };

  render() {
    return (
      <Container className="minimizado" id="chat-container">
        <Close
          onClick={() => {
            document
              .getElementById("chat-container")
              .classList.add("minimizado");
          }}
        >
          <i className="fas fa-chevron-circle-right" />
        </Close>
        {this.props.auth.user._id && localStorage.getItem("@chat-app:token") ? (
          <div style={{ display: "flex", height: "100%", widht: "100%" }}>
            <Users master={this.props.user.master} />
            {this.props.chat.open_chat ? (
              <Chat />
            ) : (
              <div className="nenhuma-conversa">
                <p>
                  <i className="far fa-comment-dots" />
                  Clique no usuário para iniciar uma conversa
                </p>
              </div>
            )}
          </div>
        ) : (
          <Login>
            <p className="offline-chat">Você está offline do chat.</p>
            <PrimaryButton
              disabled={this.state.loading}
              mr1="mt1"
              onClick={() => this.handleLogin()}
            >
              {this.state.loading ? (
                <i className="fa fa-spinner fa-pulse" />
              ) : (
                "Entrar"
              )}
            </PrimaryButton>
          </Login>
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  chat: state.chat
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...AuthActions,
      ...MessagesActions,
      ...ChatActions
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatContainer);



// WEBPACK FOOTER //
// ./src/components/ChatContainer/index.js